import React from "react";
import { Button } from "@mui/material";
import PictureAsPdfOutlined from "@mui/icons-material/PictureAsPdfOutlined";

export interface Pdf1099ButtonProps {
  payeeName: string;
  onClick: () => void;
  disabled?: boolean;
}

/** The labeled "1099" row button. The caller passes the whole row to its handler. */
export function Pdf1099Button({
  payeeName,
  onClick,
  disabled,
}: Pdf1099ButtonProps) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<PictureAsPdfOutlined />}
      onClick={onClick}
      disabled={disabled}
      aria-label={`Download 1099 for ${payeeName || "this payee"}`}
      sx={{ whiteSpace: "nowrap" }}
    >
      1099
    </Button>
  );
}

export default Pdf1099Button;
